import { useEffect } from 'react';

const STYLE_HIDDEN = 'is-hidden';

export const ExpiredEvents = (): void => {
    useEffect(() => {
        const viewDetailsExpiredEls: NodeListOf<Element> = document.querySelectorAll(
            '.js-exit-expired-events',
        );
        const expiredListingPageEl: Element | null = document.querySelector(
            '.js-expired-related-events',
        );
        const defaultListingPageEL: Element | null = document.querySelector(
            '.js-hidden-when-expired',
        );

        const viewDetails = (e: Event) => {
            e.preventDefault();
            expiredListingPageEl?.classList.add(STYLE_HIDDEN);
            defaultListingPageEL?.classList.remove(STYLE_HIDDEN);
        };

        viewDetailsExpiredEls.forEach((el: Element) =>
            el.addEventListener('click', viewDetails),
        );

        return () => {
            viewDetailsExpiredEls.forEach((el: Element) =>
                el.removeEventListener('click', viewDetails),
            );
        };
    }, []);
};
